(function () {
  'use strict';

  function isMobile() {
    return window.innerWidth < 768;
  }

  function bindCardsSection(outerEl) {
    var carouselEl = outerEl.querySelector('.cr2__carousel');
    var dotsWrap   = outerEl.querySelector('.cr2__dots-wrap');
    var btnPrev    = outerEl.querySelector('.cr2__arrow--prev');
    var btnNext    = outerEl.querySelector('.cr2__arrow--next');

    if (!carouselEl) return;

    // GUARD: if Flickity already initialized on this element, destroy it first
    if (Flickity.data(carouselEl)) {
      Flickity.data(carouselEl).destroy();
    }

    var slidesDesktop = parseInt(outerEl.getAttribute('data-slides'), 10)        || 1;
    var slidesMobile  = parseInt(outerEl.getAttribute('data-slides-mobile'), 10) || 1;
    var autoplayMs    = parseInt(carouselEl.getAttribute('data-autoplay'), 10)   || 0;
    var totalCells    = outerEl.querySelectorAll('.cr2__slide').length;

    function getSPV() {
      return isMobile() ? slidesMobile : slidesDesktop;
    }

    function setArrowVisibility(spv) {
      if (!btnPrev || !btnNext) return;
      var hide = totalCells <= spv;
      btnPrev.classList.toggle('is-hidden', hide);
      btnNext.classList.toggle('is-hidden', hide);
    }

    var spv = getSPV();
    var flkty = null;

    function makeFlickity(currentSpv) {
      // Destroy any existing instance before creating new one
      if (Flickity.data(carouselEl)) {
        Flickity.data(carouselEl).destroy();
      }
      return new Flickity(carouselEl, {
        cellAlign           : currentSpv === 1 ? 'center' : 'left',
        contain             : true,
        groupCells          : currentSpv > 1 ? currentSpv : false,
        autoPlay            : autoplayMs > 0 ? autoplayMs : false,
        pauseAutoPlayOnHover: true,
        wrapAround          : true,
        prevNextButtons     : false,
        pageDots            : false,
        fade                : false,
        adaptiveHeight      : false,
        friction            : 0.28,
        selectedAttraction  : 0.025,
        dragThreshold       : 5,
        accessibility       : true,
        freeScroll          : false,
        percentPosition     : true
      });
    }

    flkty = makeFlickity(spv);
    setArrowVisibility(spv);

    if (btnPrev) btnPrev.addEventListener('click', function () { flkty.previous(true); });
    if (btnNext) btnNext.addEventListener('click', function () { flkty.next(true); });

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var count = flkty.slides.length;
      if (count <= 1) { dotsWrap.style.display = 'none'; return; }
      dotsWrap.style.display = '';
      for (var i = 0; i < count; i++) {
        (function (idx) {
          var btn = document.createElement('button');
          btn.className = 'cr2__dot' + (idx === 0 ? ' is-selected' : '');
          btn.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
          btn.addEventListener('click', function () { flkty.select(idx); });
          dotsWrap.appendChild(btn);
        })(i);
      }
    }

    function updateDots(idx) {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('.cr2__dot').forEach(function (d, i) {
        d.classList.toggle('is-selected', i === idx);
      });
    }

    buildDots();
    flkty.on('change', function (idx) { updateDots(idx); });

    function equalHeights() {
      var slides = Array.from(carouselEl.querySelectorAll('.cr2__slide'));
      slides.forEach(function (s) { s.style.height = 'auto'; });
      if (isMobile()) {
        flkty.resize();
        return;
      }
      var max = 0;
      slides.forEach(function (s) { var h = s.offsetHeight; if (h > max) max = h; });
      slides.forEach(function (s) { s.style.height = max + 'px'; });
      flkty.resize();
    }

    var imgs = Array.from(carouselEl.querySelectorAll('img'));
    var loaded = 0;
    function imgDone() { if (++loaded >= imgs.length) equalHeights(); }
    if (imgs.length === 0) {
      setTimeout(equalHeights, 50);
    } else {
      imgs.forEach(function (img) {
        if (img.complete && img.naturalWidth > 0) { imgDone(); }
        else { img.addEventListener('load', imgDone); img.addEventListener('error', imgDone); }
      });
    }
    setTimeout(equalHeights, 300);
    setTimeout(equalHeights, 800);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var newSpv = getSPV();
        setArrowVisibility(newSpv);
        if (newSpv !== spv) {
          spv = newSpv;
          flkty.destroy();
          flkty = makeFlickity(spv);
          buildDots();
          flkty.on('change', function (idx) { updateDots(idx); });
          if (btnPrev) {
            var np = btnPrev.cloneNode(true);
            btnPrev.parentNode.replaceChild(np, btnPrev);
            btnPrev = np;
            btnPrev.addEventListener('click', function () { flkty.previous(true); });
          }
          if (btnNext) {
            var nn = btnNext.cloneNode(true);
            btnNext.parentNode.replaceChild(nn, btnNext);
            btnNext = nn;
            btnNext.addEventListener('click', function () { flkty.next(true); });
          }
        }
        setTimeout(equalHeights, 100);
      }, 200);
    });
  }

  function bindSplitSection(outerEl) {
    var carousels = outerEl.querySelectorAll('.carousel');
    if (!carousels.length) return;
    carousels.forEach(function (carouselEl) {
      if (Flickity.data(carouselEl)) Flickity.data(carouselEl).destroy();
      var autoplayMs = parseInt(carouselEl.getAttribute('data-autoplay'), 10) || 0;
      var fade       = carouselEl.getAttribute('data-fade') === 'true';
      var flkty = new Flickity(carouselEl, {
        cellAlign: 'left', contain: true,
        autoPlay: autoplayMs > 0 ? autoplayMs : false,
        pauseAutoPlayOnHover: true, wrapAround: true,
        prevNextButtons: false, pageDots: false,
        fade: fade, adaptiveHeight: true, accessibility: true, draggable: true
      });
      var allCarousels = Array.from(outerEl.querySelectorAll('.carousel'));
      if (allCarousels.length === 2) {
        var otherEl = allCarousels.find(function (el) { return el !== carouselEl; });
        var otherFlkty = null;
        flkty.on('change', function (idx) {
          if (!otherFlkty) otherFlkty = Flickity.data(otherEl);
          if (otherFlkty && otherFlkty.selectedIndex !== idx) otherFlkty.select(idx, false, true);
        });
      }
      var prevBtn = outerEl.querySelector('.flickity-prev');
      var nextBtn = outerEl.querySelector('.flickity-next');
      if (prevBtn && !prevBtn.dataset.splitBound) {
        prevBtn.dataset.splitBound = '1';
        prevBtn.addEventListener('click', function () {
          outerEl.querySelectorAll('.carousel').forEach(function (c) { var f = Flickity.data(c); if (f) f.previous(true); });
        });
      }
      if (nextBtn && !nextBtn.dataset.splitBound) {
        nextBtn.dataset.splitBound = '1';
        nextBtn.addEventListener('click', function () {
          outerEl.querySelectorAll('.carousel').forEach(function (c) { var f = Flickity.data(c); if (f) f.next(true); });
        });
      }
    });
  }

  // Delay our init to run AFTER theme's global carousel init
  function initAll() {
    document.querySelectorAll('.cr2--cards').forEach(bindCardsSection);
    document.querySelectorAll('.cr2-split').forEach(bindSplitSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      // Small delay so theme JS runs first, then we take over
      setTimeout(initAll, 50);
    });
  } else {
    setTimeout(initAll, 50);
  }

  document.addEventListener('shopify:section:load', function (e) {
    setTimeout(function () {
      var cardsEl = e.target.querySelector('.cr2--cards');
      if (cardsEl) bindCardsSection(cardsEl);
      var splitEl = e.target.querySelector('.cr2-split');
      if (splitEl) bindSplitSection(splitEl);
    }, 50);
  });

})();